// extracted by mini-css-extract-plugin
export default {"row":"row__2rkzl","profile":"profile__3uwB6","git":"git__2D4EE","link":"link__2qL3T"};